<template>
  <section class="privacypolicy-page" style="background-color: #F1F1F1;margin:25px">
    <!-- Arrow  -->
    <b-container>
      <b-row>
        <b-col>
          <div class="Privacy pt-5 pb-5 pr-1 pl-1">
            <h1>Privacy Policy</h1>
            <p>
              This privacy policy has been compiled to better serve those who are concerned with how their 'Personally
              Identifiable Information' (PII) is being used online. PII, as described in US privacy law and
              information
              security, is information that can be used on its own or with other information to identify, contact, or
              locate a
              single person, or to identify an individual in context. Please read our privacy policy carefully to get
              a clear
              understanding of how we collect, use, protect or otherwise handle your Personally Identifiable
              Information in
              accordance with our website.
            </p>
            <br>
            <h5>
              What personal information do we collect from the people that visit our blog, website or app?
            </h5>
            <p>
              When ordering or registering on our site, as appropriate, you may be asked to enter your name, email
              address,
              mailing address, phone number or other details to help you with your experience.
            </p>
            <br>
            <h5>When do we collect information?</h5>
            <p>
              We collect information from you when you register on our site or enter information on our site.
            </p>
            <br>
            <h5>How do we use your information?</h5>
            <p>
              We may use the information we collect from you when you register, make a purchase, sign up for our
              newsletter,
              respond to a survey or marketing communication, surf the website, or use certain other site features in
              the
              following ways:
              <ul class="privacyListPoints">
                <li>To administer a contest, promotion, survey or other site feature.</li>
                <li>To send periodic emails regarding your order or other products and services.</li>
                <li>To follow up with them after correspondence (live chat, email or phone inquiries)</li>
              </ul>
            </p>
            <br>
            <h5>How do we protect your information?</h5>
            <p>
              We do not use vulnerability scanning and/or scanning to PCI standards. We only provide articles and
              information.
              We never ask for credit card numbers. We do not use Malware Scanning.
            </p>
            <br>
            <h5>We do not use cookies for tracking purposes</h5>
            <p>
              You can choose to have your computer warn you each time a cookie is being sent, or you can choose to
              turn off
              all cookies. You do this through your browser settings. Since browser is a little different, look at
              your
              browser's Help Menu to learn the correct way to modify your cookies. If you turn cookies off.
            </p>
            <br>
            <h5>Third-party disclosure</h5>
            <p>
              We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information
              unless
              we provide users with advance notice. This does not include website hosting partners and other parties
              who
              assist us in operating our website, conducting our business, or serving our users, so long as those
              parties
              agree to keep this information confidential. We may also release information when it's release is
              appropriate to
              comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.
              <br>
              However, non-personally identifiable visitor information may be provided to other parties for marketing,
              advertising, or other uses.
            </p>
            <br>
            <h5>Third-party links</h5>
            <p>
              Occasionally, at our discretion, we may include or offer third-party products or services on our
              website. These
              third-party sites have separate and independent privacy policies. We therefore have no responsibility or
              liability for the content and activities of these linked sites. Nonetheless, we seek to protect the
              integrity of
              our site and welcome any feedback about these sites.
            </p>
            <br>
            <h5>Google</h5>
            <p>
              Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in
              place to
              provide a positive experience for users. <a
                href="https://support.google.com/adspolicy/answer/6008942?hl=en&visit_id=636917337870401746-626692667&rd=1"
                target="_blank"
              >Learn More</a> We use Google AdSense Advertising on our
              website. Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the
              DART cookie
              enables it to serve ads to our users based on previous visits to our site and other sites on the
              Internet. Users
              may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.
            </p>
            <br>
            <h5>We have implemented the following:</h5>
            <ul class="privacyListPoints">
              <li>Google Display Network Impression Reporting</li>
              <li>Demographics and Interests Reporting</li>
            </ul>
            <p>
              We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics
              cookies)
              and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to
              compile
              data regarding user interactions with ad impressions and other ad service functions as they relate to
              our
              website.
            </p>
            <br>
            <h5>Opting out:</h5>
            <p>
              Users can set preferences for how Google advertises to you using the Google Ad Settings page.
              Alternatively, you
              can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics
              Opt Out
              Browser add on.
            </p>
            <br>
            <h5>COPPA (Children Online Privacy Protection Act)</h5>
            <p>
              When it comes to the collection of personal information from children under the age of 13 years old, the
              Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission,
              United
              States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites
              and
              online services must do to protect children's privacy and safety online. We do not specifically market
              to
              children under the age of 13 years old.
            </p>
            <br>
            <h5>Fair Information Practices</h5>
            <p>
              The Fair Information Practices Principles form the backbone of privacy law in the United States and the
              concepts
              they include have played a significant role in the development of data protection laws around the globe.
              Understanding the Fair Information Practice Principles and how they should be implemented is critical to
              comply
              with the various privacy laws that protect personal information.
            </p>
            <br>
            <h5>
              In order to be in line with Fair Information Practices we will take the following responsive action,
              should a
              data breach occur:
            </h5>
            <p>
              We will notify you via email Within 7 business days
            </p>
            <p>
              We also agree to the Individual Redress Principle which requires that individuals have the right to
              legally
              pursue enforceable rights against data collectors and processors who fail to adhere to the law. This
              principle
              requires not only that individuals have enforceable rights against data users, but also that individuals
              have
              recourse to courts or government agencies to investigate and/or prosecute non-compliance by data
              processors.
            </p>
            <br>
            <br>
            <nuxt-link to="/">
              <h3 style="color:#F9AE43;">
                Back Home
              </h3>
            </nuxt-link>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
